import { render } from "./TheFooter.vue?vue&type=template&id=2d0043dc"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=2d0043dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__